import type { JSX } from 'react'
import type { ITOALayout } from 'blocks/TOALayout'

import {
  TextBoxBody3,
  TextBoxHeadline1,
  TextBoxHeadline3,
} from 'atoms/TextBox/Templates'
import { TOALayout } from 'blocks/TOALayout'

export interface ITOALayoutTemplate extends ITOALayout {
  title?: string
  subTitle?: string
  description?: string
  dataTestIdTitle?: string
  dataTestIdSubTitle?: string
  dataTestIdDescription?: string
}

export const TOALayoutTemplate = ({
  title = '',
  subTitle = '',
  description = '',
  dataTestIdTitle = '',
  dataTestIdSubTitle = '',
  dataTestIdDescription = '',
}: ITOALayoutTemplate): JSX.Element => {
  return (
    <TOALayout>
      <TextBoxHeadline1 dataTestId={dataTestIdTitle} title={title} />
      <TextBoxHeadline3 dataTestId={dataTestIdSubTitle} title={subTitle} />
      <TextBoxBody3 dataTestId={dataTestIdDescription} title={description} />
    </TOALayout>
  )
}
